export default __webpack_public_path__ + "9ad9d21a0ab1f2e4e9442b582618354f.svg";